/* eslint-disable no-console */
$(function () {
    var doing=false;
    const _search = {
        showSearchTypeList(e) {
            e.stopPropagation();

            $(".search-type-list").toggle();
        },
        hideSearchTypeList(e) {
            $(".search-type-list").hide();
            var target = $(e.target);
            if(target.closest(".input-search-event").length != 0) return;
            $(".cont-history").hide();
            $(".more-history").hide();
        },
        checkSearchType() {
            const val = $(this).html();
            $("._searchType").val(val);
        },
        putHistory(v=$('#_keywords').val().trim()) {
            // 设置历史记录存储
            let history = window.localStorage.getItem("pc_history")||[];
            history = typeof(history)=="string"?JSON.parse(history):history;
            if(!history.includes(v)){
                v==""?"":history.unshift(v)
                window.localStorage.setItem("pc_history",JSON.stringify(history))
            }
            // if(history&&history.length>0){
            //     if(!history.includes(v)){
            //         $("#_keywords").val()==""?"":history.unshift(v)
            //         window.localStorage.setItem("pc_history",JSON.stringify(history))
            //     }
            // }else{
            //     if(!history.includes(v)){
            //         $("#_keywords").val()==""?"":history.unshift(v);
            //         window.localStorage.setItem("pc_history",JSON.stringify(history))
            //     }
            // }

            // if (
            //     [
            //         "/rumor/videoList",
            //         "/rumor/imgList",
            //         "/rumor/audioList"
            //     ].indexOf(location.pathname) !== -1
            // ) {
            //     // 视频、图片和音频列表
            //     var query = window.util.queryString();
            //     var title = $("#_keywords").val();

            //     query.title = title;
            //     query.type = query.type ? query.type : 0;
            //     query.keyword = query.keyword ? query.keyword : "";
            //     query.page = 1;
            //     var queryStr = window.util.formatQuery(query);

            //     window.location.href = `${location.pathname}?${queryStr}`;
            // } else {
            //     const  keywords = $("#_keywords").val();

            //     window.location.href = `/rumor/rumorlist?title=${keywords}`;
            // }
           
        },
        delHistory(e){
            let history=window.localStorage.getItem("pc_history")!=''&&window.localStorage.getItem("pc_history")!=null?JSON.parse(window.localStorage.getItem("pc_history")):[];
            let arr = history.filter((index)=>{return index !==  $(this).attr("data-val")});
            window.localStorage.setItem("pc_history",JSON.stringify(arr));
            $(this).parent().remove();
            arr.length==0?$(".history-content").hide():$(".history-content").show();
            e.stopPropagation()
        },
        showMoreList(e){
            e.stopPropagation();
            if(!doing){
                if($("#_keywords").val()==""){
                    $(".cont-history").show();
                    $(".more-history").hide();
                }else{
                    $(".cont-history").hide();
                    $(".more-history").show();
                    _search.getMoreList($("#_keywords").val())
                }
            }
            // if($(this).val()==""){
            //     $(".cont-history").show();
            //     $(".more-history").hide();
            // }else{
            //     $(".cont-history").hide();
            //     $(".more-history").show();
            //     _search.getMoreList($(this).val())
            // }
            
        },
        getMoreList(v){
            let ajaxUrl="/rumor/getTitleBySearch",urlHtml="/rumor/rumorajaxlist",searchType=1;
             if(window.location.pathname=="/rumor/expertajaxlist"){
                urlHtml="/rumor/expertajaxlist"
                searchType=2
             }
            window.util.ajax({
                url: ajaxUrl,
                type: "get",
                data:{
                    title:v,
                    searchType:searchType
                },
                callback({code, data}) {
                    let html="";
                   if (code == 0) {
                    let len=data.length;
                    for(let i=0;i<len;i++){
                        html+=`<li>
                        <a class="text-ellipsis max-300 cur-pointer think-more" data-href="${urlHtml}?title=${data[i].search}" data-name="${data[i].search}">
                           ${data[i].title}
                        </a>
                      </li>` 
                    }
                    len==0?html=`<li>
                            <a class="text-ellipsis max-300">
                                没有找到符合条件的结果
                            </a>
                        </li>` :"";
                     }
                    $(".more-history-list").html(html);
                }
            });
        },

        clearHistory(){
            window.localStorage.removeItem("pc_history");
            $(".history-content").hide();
        },
        searchClick(){
            _search.putHistory();
            const  keywords = $("#_keywords").val().trim();
            if(window.location.pathname=="/rumor/expertajaxlist"){
                window.location.href = `/rumor/expertajaxlist?title=${keywords}`;
            }else{
                window.location.href = `/rumor/rumorajaxlist?title=${keywords}`;
            }
        },
        thinkMoreClick(){
            _search.putHistory($(this).attr("data-name"));
            window.location.href = $(this).attr("data-href");
            
        },
        listScreen(){
            _search.putHistory();
            var title =$("#_keywords").val();
            window.location.href=$(this).attr("data-href")+`&title=${title}`;
        },

        init(){
            let history = window.localStorage.getItem("pc_history")||[];
            history = typeof(history)=="string"?JSON.parse(history):history;
            history=history.slice(0, 10);
            window.localStorage.setItem("pc_history",JSON.stringify(history))
            let html=""
            let len=history.length;
            for(let i=0;i<len;i++){
                html+=`<li class="clearfix">
                <a class="fl text-ellipsis max-238" href="/rumor/rumorajaxlist?title=${history[i]}">${history[i]}</a>
                <span class="del-history fr" data-val="${history[i]}"></span>
              </li>` 
            }
            $(".history-search-box").html(html);
            len==0?$(".history-content").hide():"";
        }
    };
_search.init()
    $(document)
        .on("click", "._searchTypeBox", _search.showSearchTypeList)
        .on("click", "._searchList li", _search.checkSearchType)
        .on("click", _search.hideSearchTypeList)
        // 跳转页面
        .on("click", "._searchBtn", _search.searchClick)
        .on("click input","#_keywords",_search.showMoreList)
        .on("click",".del-history",_search.delHistory)
        .on("click",".clear-history",_search.clearHistory)
        .on("click", ".think-more", _search.thinkMoreClick)
        .on("click",".rumor-type_list-item",_search.listScreen)

        document.getElementById('_keywords').addEventListener('compositionstart',function(){
            doing=true;
        },false);
        // document.getElementById('_keywords').addEventListener('input,click',function(){
        //     if(!doing){
        //         if($("#_keywords").val()==""){
        //             $(".cont-history").show();
        //             $(".more-history").hide();
        //         }else{
        //             $(".cont-history").hide();
        //             $(".more-history").show();
        //             console.log(123)
        //             // _search.getMoreList($("#_keywords").val())
        //         }
        //     }
        // },false);
     
        document.getElementById('_keywords').addEventListener('compositionend',function(){
            doing=false;
            $(".cont-history").hide();
            $(".more-history").show();
            _search.getMoreList($("#_keywords").val())
        },false);
});
